var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefunded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1573_4967)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM10 6.55049C10 6.66095 9.91046 6.75049 9.8 6.75049L4.56178 6.75049L5.94142 8.13013C5.97893 8.16764 6 8.21851 6 8.27155V9.82719C6 10.0054 5.78457 10.0946 5.65858 9.96861L2.22059 6.53062C1.9277 6.23773 1.9277 5.76285 2.22059 5.46996L5.65858 2.03197C5.78457 1.90598 6 1.99521 6 2.17339V3.72903C6 3.78207 5.97893 3.83294 5.94142 3.87045L4.56138 5.25049L9.8 5.25049C9.91046 5.25049 10 5.34003 10 5.45049V6.55049Z",
    fill: "#C096F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1573_4967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefunded);
export default __webpack_public_path__ + "static/media/refunded.5b54f366eb0e53549537fa45c5954a5c.svg";
export { ForwardRef as ReactComponent };